import { PrivateInformationTableRowType } from '../types';

export const privateInformationRows: PrivateInformationTableRowType[] = [
  {
    label: 'FIRSTNAME',
    accessor: 'firstname',
  },
  {
    label: 'LASTNAME',
    accessor: 'lastname',
  },
  {
    label: 'NICKNAME',
    accessor: 'nickname',
  },
  {
    label: 'BIRTHDAY',
    accessor: 'birthdate',
  },
  {
    label: 'PRIVATE_PHONE',
    accessor: 'contact.phone',
  },
  {
    label: 'PRIVATE_MOBILE',
    accessor: 'contact.mobile',
  },
  {
    label: 'PRIVATE_EMAIL',
    accessor: 'contact.email',
  },
  {
    label: 'PRIVATE_ADDRESS',
    accessor: 'address',
  },
];
